"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestExternalDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const guest_external_json_1 = require("./guest-external-json");
exports.GuestExternalDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('GuestExternal', guest_external_json_1.GuestExternalJsonMapper);
